var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 4,
    width: 3,
    height: 1.4,
    transform: "rotate(90 19 4)",
    fill: "#7783A1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 10,
    width: 10,
    height: 1.4,
    transform: "rotate(90 19 10)",
    fill: "#7783A1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 10,
    height: 1.4,
    transform: "rotate(90 13 4)",
    fill: "#7783A1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17,
    width: 3,
    height: 1.4,
    transform: "rotate(90 13 17)",
    fill: "#7783A1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 5,
    height: 1.4,
    transform: "rotate(90 7 4)",
    fill: "#7783A1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 8,
    height: 1.4,
    transform: "rotate(90 7 12)",
    fill: "#7783A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7998 8.5C15.7998 9.88071 16.9191 11 18.2998 11C19.6805 11 20.7998 9.88071 20.7998 8.5C20.7998 7.11929 19.6805 6 18.2998 6C16.9191 6 15.7998 7.11929 15.7998 8.5ZM17.2998 8.5C17.2998 9.05228 17.7475 9.5 18.2998 9.5C18.8521 9.5 19.2998 9.05228 19.2998 8.5C19.2998 7.94772 18.8521 7.5 18.2998 7.5C17.7475 7.5 17.2998 7.94772 17.2998 8.5Z",
    fill: "#7783A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7998 15.5C9.7998 16.8807 10.9191 18 12.2998 18C13.6805 18 14.7998 16.8807 14.7998 15.5C14.7998 14.1193 13.6805 13 12.2998 13C10.9191 13 9.7998 14.1193 9.7998 15.5ZM11.2998 15.5C11.2998 16.0523 11.7475 16.5 12.2998 16.5C12.8521 16.5 13.2998 16.0523 13.2998 15.5C13.2998 14.9477 12.8521 14.5 12.2998 14.5C11.7475 14.5 11.2998 14.9477 11.2998 15.5Z",
    fill: "#7783A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7998 10.5C3.7998 11.8807 4.91909 13 6.2998 13C7.68052 13 8.7998 11.8807 8.7998 10.5C8.7998 9.11929 7.68052 8 6.2998 8C4.91909 8 3.7998 9.11929 3.7998 10.5ZM5.2998 10.5C5.2998 11.0523 5.74751 11.5 6.2998 11.5C6.85208 11.5 7.2998 11.0523 7.2998 10.5C7.2998 9.94772 6.85208 9.5 6.2998 9.5C5.74751 9.5 5.2998 9.94772 5.2998 10.5Z",
    fill: "#7783A1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.1bab0492f25b0a076d4de042b43ed715.svg";
export { ForwardRef as ReactComponent };